// extracted by mini-css-extract-plugin
export default {"root":"SuperBatchTypeChip_root__B4cUt"};